import { useEffect } from 'react';

import PropTypes from 'prop-types';
import { trackPage } from '../../Pages/LeadVettingPage/utils';

// This is a component which updates pageview analytics everytime the component is rendered -
// which is necessary for single page application pages with no changes in the url

const PageviewHandler = (props) => {
  useEffect(() => {
    trackPage(`${window.location.pathname}${props.path}`);
  }, []);
  return null;
};

PageviewHandler.propTypes = {
  path: PropTypes.string,
};

export default PageviewHandler;
